import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import moment from 'moment';

import { DEFAULT_EARLIEST_HISTORICAL_DATA_DATE } from '../redux/constants';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { DATE_TIME_IN_YYYY_MM_DD_FORMAT } from './constants/constants'

const MIN_DATE = moment(DEFAULT_EARLIEST_HISTORICAL_DATA_DATE).format(DATE_TIME_IN_YYYY_MM_DD_FORMAT);

const WEEKS = "weeks";
const MONTHS = "months";
const YEARS = "years";
const ranges = {
  Today: [moment(), moment()],
  '1 Week Ago': [moment().subtract(1, WEEKS), moment().subtract(1, WEEKS)],
  '1 Month Ago': [moment().subtract(1, MONTHS), moment().subtract(1, MONTHS)],
  '6 Months Ago': [moment().subtract(6, MONTHS), moment().subtract(6, MONTHS)],
  '1 Year Ago': [moment().subtract(1, YEARS), moment().subtract(1, YEARS)],
  'Earliest Possible Date': [MIN_DATE, MIN_DATE]
};

const SingleDateCalendar = props => {
  const [isActive, setActive] = useState(false);

  useEffect(() => {
    const el = document.getElementsByClassName('daterangepicker');
    if (el.length) {
      el[0].classList.add('custom-date-picker-topics');

      if (!props.showRanges) {
        const rangesElement = el[0].querySelector('.ranges');
        if (rangesElement) {
          rangesElement.style.display = 'none';
        }
        const calendarElement = el[0].querySelector('.drp-calendar');
        if (calendarElement) {
          calendarElement.style.borderRadius = '10px';
        }
      }
    }
  }, [props.showRanges]);

  function handleEvent(event, picker) {
    event.type === 'show' ? setActive(true) : setActive(false);
    const chosenEarliestHistoricalDataDate = moment(picker.startDate).format(DATE_TIME_IN_YYYY_MM_DD_FORMAT);
    props.setEarliestHistoricalDataDate(chosenEarliestHistoricalDataDate);
  }
  return (
    <div className='add-topic-calendar'>
      <DateRangePicker
        minDate={MIN_DATE}
        maxDate={moment()}
        singleDatePicker={true}
        showDropdowns={true}
        ranges={ranges}
        alwaysShowCalendars={true}
        autoApply={true}
        locale={{ 'format': DATE_TIME_IN_YYYY_MM_DD_FORMAT }}
        showCustomRangeLabel={false}
        onApply={(event, value) => handleEvent(event, value)}
        startDate={props.earliestHistoricalDataDate}
        endDate={props.earliestHistoricalDataDate}
        opens="right"
        drops={props.drops}
      >
        <div className={`input-container ${isActive ? 'active' : ''}`}>
          <input type="text" placeholder={props.earliestHistoricalDataDate} readOnly defaultValue=""></input>
          <i className="la la-calendar icon" />
        </div>
      </DateRangePicker>
    </div>
  );
};

SingleDateCalendar.propTypes = {
  earliestHistoricalDataDate: PropTypes.string.isRequired,
  setEarliestHistoricalDataDate: PropTypes.func.isRequired,
  drops: PropTypes.string,
  showRanges: PropTypes.bool
};

export default SingleDateCalendar;


// WEBPACK FOOTER //
// ./src/features/topics/components/SingleDateCalendar.js